module.exports = __webpack_public_path__ + "img/logo-square.03321ac9.png";